import _toConsumableArray from "/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["__scopeRovingFocusGroup", "orientation", "dir", "loop", "currentTabStopId", "defaultCurrentTabStopId", "onCurrentTabStopIdChange", "onEntryFocus"],
    _excluded2 = ["__scopeRovingFocusGroup", "focusable", "active"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e4) { throw _e4; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e5) { didErr = true; err = _e5; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useControllableState as e } from "@radix-ui/react-use-controllable-state";
import { useCallbackRef as o } from "@radix-ui/react-use-callback-ref";
import { Primitive as r } from "@radix-ui/react-primitive";
import { useId as t } from "@radix-ui/react-id";
import { createContextScope as n } from "@radix-ui/react-context";
import { useComposedRefs as i } from "@radix-ui/react-compose-refs";
import { createCollection as c } from "@radix-ui/react-collection";
import { composeEventHandlers as u } from "@radix-ui/primitive";
import * as s from "react";
import a from "@babel/runtime/helpers/esm/extends";

var f = {
  bubbles: !1,
  cancelable: !0
},
    _c = c("RovingFocusGroup"),
    _c2 = _slicedToArray(_c, 3),
    p = _c2[0],
    l = _c2[1],
    m = _c2[2],
    _n = n("RovingFocusGroup", [m]),
    _n2 = _slicedToArray(_n, 2),
    d = _n2[0],
    v = _n2[1];

export { v as createRovingFocusGroupScope };

var _d = d("RovingFocusGroup"),
    _d2 = _slicedToArray(_d, 2),
    g = _d2[0],
    F = _d2[1];

export var RovingFocusGroup = /*#__PURE__*/s.forwardRef(function (e, o) {
  return /*#__PURE__*/s.createElement(p.Provider, {
    scope: e.__scopeRovingFocusGroup
  }, /*#__PURE__*/s.createElement(p.Slot, {
    scope: e.__scopeRovingFocusGroup
  }, /*#__PURE__*/s.createElement(w, a({}, e, {
    ref: o
  }))));
});
/*#__PURE__*/

var w = /*#__PURE__*/s.forwardRef(function (t, n) {
  var c = t.__scopeRovingFocusGroup,
      p = t.orientation,
      _t$dir = t.dir,
      m = _t$dir === void 0 ? "ltr" : _t$dir,
      _t$loop = t.loop,
      d = _t$loop === void 0 ? !1 : _t$loop,
      v = t.currentTabStopId,
      F = t.defaultCurrentTabStopId,
      w = t.onCurrentTabStopIdChange,
      b = t.onEntryFocus,
      x = _objectWithoutProperties(t, _excluded),
      E = s.useRef(null),
      I = i(n, E),
      _e = e({
    prop: v,
    defaultProp: F,
    onChange: w
  }),
      _e2 = _slicedToArray(_e, 2),
      _e2$ = _e2[0],
      G = _e2$ === void 0 ? null : _e2$,
      h = _e2[1],
      _s$useState = s.useState(!1),
      _s$useState2 = _slicedToArray(_s$useState, 2),
      T = _s$useState2[0],
      A = _s$useState2[1],
      y = o(b),
      D = l(c),
      S = s.useRef(!1);

  return s.useEffect(function () {
    var e = E.current;
    if (e) return e.addEventListener("rovingFocusGroup.onEntryFocus", y), function () {
      return e.removeEventListener("rovingFocusGroup.onEntryFocus", y);
    };
  }, [y]), /*#__PURE__*/s.createElement(g, {
    scope: c,
    orientation: p,
    dir: m,
    loop: d,
    currentTabStopId: G,
    onItemFocus: s.useCallback(function (e) {
      return h(e);
    }, [h]),
    onItemShiftTab: s.useCallback(function () {
      return A(!0);
    }, [])
  }, /*#__PURE__*/s.createElement(r.div, a({
    tabIndex: T ? -1 : 0,
    "data-orientation": p
  }, x, {
    ref: I,
    style: _objectSpread({
      outline: "none"
    }, t.style),
    onMouseDown: u(t.onMouseDown, function () {
      S.current = !0;
    }),
    onFocus: u(t.onFocus, function (e) {
      var o = !S.current;

      if (e.target === e.currentTarget && o && !T) {
        var _o = new Event("rovingFocusGroup.onEntryFocus", f);

        if (e.currentTarget.dispatchEvent(_o), !_o.defaultPrevented) {
          var _e3 = D().filter(function (e) {
            return e.focusable;
          });

          R([_e3.find(function (e) {
            return e.active;
          }), _e3.find(function (e) {
            return e.id === G;
          })].concat(_toConsumableArray(_e3)).filter(Boolean).map(function (e) {
            return e.ref.current;
          }));
        }
      }

      S.current = !1;
    }),
    onBlur: u(t.onBlur, function () {
      return A(!1);
    })
  })));
});
export var RovingFocusGroupItem = /*#__PURE__*/s.forwardRef(function (e, o) {
  var n = e.__scopeRovingFocusGroup,
      _e$focusable = e.focusable,
      i = _e$focusable === void 0 ? !0 : _e$focusable,
      _e$active = e.active,
      c = _e$active === void 0 ? !1 : _e$active,
      f = _objectWithoutProperties(e, _excluded2),
      m = t(),
      d = F("RovingFocusGroupItem", n),
      v = d.currentTabStopId === m,
      g = l(n);
  /*#__PURE__*/


  return s.createElement(p.ItemSlot, {
    scope: n,
    id: m,
    focusable: i,
    active: c
  }, /*#__PURE__*/s.createElement(r.span, a({
    tabIndex: v ? 0 : -1,
    "data-orientation": d.orientation
  }, f, {
    ref: o,
    onMouseDown: u(e.onMouseDown, function (e) {
      i ? d.onItemFocus(m) : e.preventDefault();
    }),
    onFocus: u(e.onFocus, function () {
      return d.onItemFocus(m);
    }),
    onKeyDown: u(e.onKeyDown, function (e) {
      if ("Tab" === e.key && e.shiftKey) return void d.onItemShiftTab();
      if (e.target !== e.currentTarget) return;

      var o = function (e, o, r) {
        var t = function (e, o) {
          return "rtl" !== o ? e : "ArrowLeft" === e ? "ArrowRight" : "ArrowRight" === e ? "ArrowLeft" : e;
        }(e.key, r);

        return "vertical" === o && ["ArrowLeft", "ArrowRight"].includes(t) || "horizontal" === o && ["ArrowUp", "ArrowDown"].includes(t) ? void 0 : b[t];
      }(e, d.orientation, d.dir);

      if (void 0 !== o) {
        e.preventDefault();

        var _n3 = g().filter(function (e) {
          return e.focusable;
        }).map(function (e) {
          return e.ref.current;
        });

        if ("last" === o) _n3.reverse();else if ("prev" === o || "next" === o) {
          "prev" === o && _n3.reverse();

          var _i = _n3.indexOf(e.currentTarget);

          _n3 = d.loop ? (t = _i + 1, (r = _n3).map(function (e, o) {
            return r[(t + o) % r.length];
          })) : _n3.slice(_i + 1);
        }
        setTimeout(function () {
          return R(_n3);
        });
      }

      var r, t;
    })
  })));
});
/*#__PURE__*/

var b = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};

function R(e) {
  var o = document.activeElement;

  var _iterator = _createForOfIteratorHelper(e),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _r = _step.value;
      if (_r === o) return;
      if (_r.focus(), document.activeElement !== o) return;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

export var Root = RovingFocusGroup;
export var Item = RovingFocusGroupItem;